export { default } from "./table-heading";
